import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { API, getSessionId } from "@/lib/api";

// Traite le retour de l'auth Google (fragment #session_id=...), échange le
// session_id côté backend, rattache la session anonyme, puis redirige.
const AuthCallback = () => {
    const navigate = useNavigate();
    const processed = useRef(false);

    useEffect(() => {
        if (processed.current) return;
        processed.current = true;
        (async () => {
            const hash = window.location.hash || "";
            const m = hash.match(/session_id=([^&]+)/);
            const sid = m ? m[1] : null;
            if (!sid) {
                navigate("/connexion");
                return;
            }
            try {
                const res = await fetch(`${API}/auth/session`, {
                    method: "POST",
                    credentials: "include",
                    headers: {
                        "Content-Type": "application/json",
                        "X-Session-ID": sid,
                    },
                    body: JSON.stringify({ anon_session_id: getSessionId() }),
                });
                const user = await res.json();
                window.history.replaceState({}, "", window.location.pathname);
                const ret = localStorage.getItem("revanche_auth_return");
                if (ret) {
                    localStorage.removeItem("revanche_auth_return");
                    navigate(ret);
                } else {
                    navigate("/analyse-terminee", { state: { user } });
                }
            } catch (e) {
                window.history.replaceState({}, "", window.location.pathname);
                const ret = localStorage.getItem("revanche_auth_return");
                if (ret) {
                    localStorage.removeItem("revanche_auth_return");
                    navigate(ret);
                } else {
                    navigate("/connexion");
                }
            }
        })();
    }, [navigate]);

    return <div className="fixed inset-0 bg-black" />;
};

export default AuthCallback;
